var At = Object.defineProperty;
var _t = (n, t, e) => t in n ? At(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var E = (n, t, e) => (_t(n, typeof t != "symbol" ? t + "" : t, e), e);
import * as M from "react";
import Ke from "react";
import { cn as ge, Button as ee } from "@spiaggeit/spit-ui";
import { DateTime as O } from "luxon";
import { isSameDay as Nt, getCalendarsByPeriod as Ot } from "./dateUtils.js";
var pe = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Be;
function jt() {
  return Be || (Be = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Ke, t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), D = Symbol.iterator, S = "@@iterator";
    function _(a) {
      if (a === null || typeof a != "object")
        return null;
      var d = D && a[D] || a[S];
      return typeof d == "function" ? d : null;
    }
    var j = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(a) {
      {
        for (var d = arguments.length, u = new Array(d > 1 ? d - 1 : 0), f = 1; f < d; f++)
          u[f - 1] = arguments[f];
        q("error", a, u);
      }
    }
    function q(a, d, u) {
      {
        var f = j.ReactDebugCurrentFrame, x = f.getStackAddendum();
        x !== "" && (d += "%s", u = u.concat([x]));
        var C = u.map(function(m) {
          return String(m);
        });
        C.unshift("Warning: " + d), Function.prototype.apply.call(console[a], console, C);
      }
    }
    var et = !1, tt = !1, rt = !1, at = !1, nt = !1, be;
    be = Symbol.for("react.module.reference");
    function ot(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === r || a === i || nt || a === o || a === g || a === p || at || a === v || et || tt || rt || typeof a == "object" && a !== null && (a.$$typeof === h || a.$$typeof === w || a.$$typeof === l || a.$$typeof === s || a.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === be || a.getModuleId !== void 0));
    }
    function it(a, d, u) {
      var f = a.displayName;
      if (f)
        return f;
      var x = d.displayName || d.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function me(a) {
      return a.displayName || "Context";
    }
    function Y(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case r:
          return "Fragment";
        case e:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case g:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case s:
            var d = a;
            return me(d) + ".Consumer";
          case l:
            var u = a;
            return me(u._context) + ".Provider";
          case c:
            return it(a, a.render, "ForwardRef");
          case w:
            var f = a.displayName || null;
            return f !== null ? f : Y(a.type) || "Memo";
          case h: {
            var x = a, C = x._payload, m = x._init;
            try {
              return Y(m(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, H = 0, ye, ve, xe, ke, we, De, Ce;
    function Ee() {
    }
    Ee.__reactDisabledLog = !0;
    function dt() {
      {
        if (H === 0) {
          ye = console.log, ve = console.info, xe = console.warn, ke = console.error, we = console.group, De = console.groupCollapsed, Ce = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        H++;
      }
    }
    function st() {
      {
        if (H--, H === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, a, {
              value: ye
            }),
            info: B({}, a, {
              value: ve
            }),
            warn: B({}, a, {
              value: xe
            }),
            error: B({}, a, {
              value: ke
            }),
            group: B({}, a, {
              value: we
            }),
            groupCollapsed: B({}, a, {
              value: De
            }),
            groupEnd: B({}, a, {
              value: Ce
            })
          });
        }
        H < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = j.ReactCurrentDispatcher, ae;
    function J(a, d, u) {
      {
        if (ae === void 0)
          try {
            throw Error();
          } catch (x) {
            var f = x.stack.trim().match(/\n( *(at )?)/);
            ae = f && f[1] || "";
          }
        return `
` + ae + a;
      }
    }
    var ne = !1, G;
    {
      var lt = typeof WeakMap == "function" ? WeakMap : Map;
      G = new lt();
    }
    function Se(a, d) {
      if (!a || ne)
        return "";
      {
        var u = G.get(a);
        if (u !== void 0)
          return u;
      }
      var f;
      ne = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = re.current, re.current = null, dt();
      try {
        if (d) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (F) {
              f = F;
            }
            Reflect.construct(a, [], m);
          } else {
            try {
              m.call();
            } catch (F) {
              f = F;
            }
            a.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            f = F;
          }
          a();
        }
      } catch (F) {
        if (F && f && typeof F.stack == "string") {
          for (var b = F.stack.split(`
`), A = f.stack.split(`
`), L = b.length - 1, T = A.length - 1; L >= 1 && T >= 0 && b[L] !== A[T]; )
            T--;
          for (; L >= 1 && T >= 0; L--, T--)
            if (b[L] !== A[T]) {
              if (L !== 1 || T !== 1)
                do
                  if (L--, T--, T < 0 || b[L] !== A[T]) {
                    var N = `
` + b[L].replace(" at new ", " at ");
                    return a.displayName && N.includes("<anonymous>") && (N = N.replace("<anonymous>", a.displayName)), typeof a == "function" && G.set(a, N), N;
                  }
                while (L >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        ne = !1, re.current = C, st(), Error.prepareStackTrace = x;
      }
      var $ = a ? a.displayName || a.name : "", Ie = $ ? J($) : "";
      return typeof a == "function" && G.set(a, Ie), Ie;
    }
    function ct(a, d, u) {
      return Se(a, !1);
    }
    function ut(a) {
      var d = a.prototype;
      return !!(d && d.isReactComponent);
    }
    function Z(a, d, u) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return Se(a, ut(a));
      if (typeof a == "string")
        return J(a);
      switch (a) {
        case g:
          return J("Suspense");
        case p:
          return J("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case c:
            return ct(a.render);
          case w:
            return Z(a.type, d, u);
          case h: {
            var f = a, x = f._payload, C = f._init;
            try {
              return Z(C(x), d, u);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, Me = {}, Le = j.ReactDebugCurrentFrame;
    function X(a) {
      if (a) {
        var d = a._owner, u = Z(a.type, a._source, d ? d.type : null);
        Le.setExtraStackFrame(u);
      } else
        Le.setExtraStackFrame(null);
    }
    function gt(a, d, u, f, x) {
      {
        var C = Function.call.bind(K);
        for (var m in a)
          if (C(a, m)) {
            var b = void 0;
            try {
              if (typeof a[m] != "function") {
                var A = Error((f || "React class") + ": " + u + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw A.name = "Invariant Violation", A;
              }
              b = a[m](d, m, f, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              b = L;
            }
            b && !(b instanceof Error) && (X(x), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", u, m, typeof b), X(null)), b instanceof Error && !(b.message in Me) && (Me[b.message] = !0, X(x), R("Failed %s type: %s", u, b.message), X(null));
          }
      }
    }
    var pt = Array.isArray;
    function oe(a) {
      return pt(a);
    }
    function ht(a) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, u = d && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return u;
      }
    }
    function ft(a) {
      try {
        return Te(a), !1;
      } catch {
        return !0;
      }
    }
    function Te(a) {
      return "" + a;
    }
    function Pe(a) {
      if (ft(a))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ht(a)), Te(a);
    }
    var V = j.ReactCurrentOwner, bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, Ae, ie;
    ie = {};
    function mt(a) {
      if (K.call(a, "ref")) {
        var d = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function yt(a) {
      if (K.call(a, "key")) {
        var d = Object.getOwnPropertyDescriptor(a, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function vt(a, d) {
      if (typeof a.ref == "string" && V.current && d && V.current.stateNode !== d) {
        var u = Y(V.current.type);
        ie[u] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(V.current.type), a.ref), ie[u] = !0);
      }
    }
    function xt(a, d) {
      {
        var u = function() {
          Re || (Re = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        u.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function kt(a, d) {
      {
        var u = function() {
          Ae || (Ae = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        u.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var wt = function(a, d, u, f, x, C, m) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: a,
        key: d,
        ref: u,
        props: m,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Dt(a, d, u, f, x) {
      {
        var C, m = {}, b = null, A = null;
        u !== void 0 && (Pe(u), b = "" + u), yt(d) && (Pe(d.key), b = "" + d.key), mt(d) && (A = d.ref, vt(d, x));
        for (C in d)
          K.call(d, C) && !bt.hasOwnProperty(C) && (m[C] = d[C]);
        if (a && a.defaultProps) {
          var L = a.defaultProps;
          for (C in L)
            m[C] === void 0 && (m[C] = L[C]);
        }
        if (b || A) {
          var T = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          b && xt(m, T), A && kt(m, T);
        }
        return wt(a, b, A, x, f, V.current, m);
      }
    }
    var de = j.ReactCurrentOwner, _e = j.ReactDebugCurrentFrame;
    function z(a) {
      if (a) {
        var d = a._owner, u = Z(a.type, a._source, d ? d.type : null);
        _e.setExtraStackFrame(u);
      } else
        _e.setExtraStackFrame(null);
    }
    var se;
    se = !1;
    function le(a) {
      return typeof a == "object" && a !== null && a.$$typeof === t;
    }
    function Ne() {
      {
        if (de.current) {
          var a = Y(de.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function Ct(a) {
      {
        if (a !== void 0) {
          var d = a.fileName.replace(/^.*[\\\/]/, ""), u = a.lineNumber;
          return `

Check your code at ` + d + ":" + u + ".";
        }
        return "";
      }
    }
    var Oe = {};
    function Et(a) {
      {
        var d = Ne();
        if (!d) {
          var u = typeof a == "string" ? a : a.displayName || a.name;
          u && (d = `

Check the top-level render call using <` + u + ">.");
        }
        return d;
      }
    }
    function je(a, d) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var u = Et(d);
        if (Oe[u])
          return;
        Oe[u] = !0;
        var f = "";
        a && a._owner && a._owner !== de.current && (f = " It was passed a child from " + Y(a._owner.type) + "."), z(a), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, f), z(null);
      }
    }
    function Ye(a, d) {
      {
        if (typeof a != "object")
          return;
        if (oe(a))
          for (var u = 0; u < a.length; u++) {
            var f = a[u];
            le(f) && je(f, d);
          }
        else if (le(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var x = _(a);
          if (typeof x == "function" && x !== a.entries)
            for (var C = x.call(a), m; !(m = C.next()).done; )
              le(m.value) && je(m.value, d);
        }
      }
    }
    function St(a) {
      {
        var d = a.type;
        if (d == null || typeof d == "string")
          return;
        var u;
        if (typeof d == "function")
          u = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === w))
          u = d.propTypes;
        else
          return;
        if (u) {
          var f = Y(d);
          gt(u, a.props, "prop", f, a);
        } else if (d.PropTypes !== void 0 && !se) {
          se = !0;
          var x = Y(d);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mt(a) {
      {
        for (var d = Object.keys(a.props), u = 0; u < d.length; u++) {
          var f = d[u];
          if (f !== "children" && f !== "key") {
            z(a), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), z(null);
            break;
          }
        }
        a.ref !== null && (z(a), R("Invalid attribute `ref` supplied to `React.Fragment`."), z(null));
      }
    }
    function Fe(a, d, u, f, x, C) {
      {
        var m = ot(a);
        if (!m) {
          var b = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var A = Ct(x);
          A ? b += A : b += Ne();
          var L;
          a === null ? L = "null" : oe(a) ? L = "array" : a !== void 0 && a.$$typeof === t ? (L = "<" + (Y(a.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : L = typeof a, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, b);
        }
        var T = Dt(a, d, u, x, C);
        if (T == null)
          return T;
        if (m) {
          var N = d.children;
          if (N !== void 0)
            if (f)
              if (oe(N)) {
                for (var $ = 0; $ < N.length; $++)
                  Ye(N[$], a);
                Object.freeze && Object.freeze(N);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ye(N, a);
        }
        return a === r ? Mt(T) : St(T), T;
      }
    }
    function Lt(a, d, u) {
      return Fe(a, d, u, !0);
    }
    function Tt(a, d, u) {
      return Fe(a, d, u, !1);
    }
    var Pt = Tt, Rt = Lt;
    W.Fragment = r, W.jsx = Pt, W.jsxs = Rt;
  }()), W;
}
var U = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ze;
function Yt() {
  if (ze)
    return U;
  ze = 1;
  var n = Ke, t = Symbol.for("react.element"), e = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(s, c, g) {
    var p, w = {}, h = null, v = null;
    g !== void 0 && (h = "" + g), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (v = c.ref);
    for (p in c)
      r.call(c, p) && !i.hasOwnProperty(p) && (w[p] = c[p]);
    if (s && s.defaultProps)
      for (p in c = s.defaultProps, c)
        w[p] === void 0 && (w[p] = c[p]);
    return { $$typeof: t, type: s, key: h, ref: v, props: w, _owner: o.current };
  }
  return U.Fragment = e, U.jsx = l, U.jsxs = l, U;
}
process.env.NODE_ENV === "production" ? pe.exports = Yt() : pe.exports = jt();
var y = pe.exports, P;
let k = (P = class extends Date {
  constructor(e = null, r = "YYYY-MM-DD", o = "en-US") {
    super(P.parseDateTime(e, r, o));
    E(this, "lang");
    this.lang = o;
  }
  static parseDateTime(e, r = "YYYY-MM-DD", o = "en-US") {
    if (!e)
      return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
    if (e instanceof P)
      return e.toJSDate();
    if (e instanceof Date)
      return e;
    if (/^-?\d{10,}$/.test(String(e)))
      return new Date(Number(e));
    if (typeof e == "string") {
      const i = [];
      let l = null;
      for (; (l = P.regex.exec(r)) != null; )
        l[1] !== "\\" && i.push(l);
      if (i.length) {
        const s = { year: null, month: null, shortMonth: null, longMonth: null, day: null, hour: 0, minute: 0, second: 0, ampm: null, value: "" };
        i[0].index > 0 && (s.value += ".*?");
        for (const [g, p] of Object.entries(i)) {
          const w = Number(g), { group: h, pattern: v } = P.formatPatterns(p[0], o);
          s[h] = w + 1, s.value += v, s.value += ".*?";
        }
        const c = new RegExp(`^${s.value}$`);
        if (c.test(e)) {
          const g = c.exec(e), p = Number(g[s.year]);
          let w = null;
          s.month ? w = Number(g[s.month]) - 1 : s.shortMonth ? w = P.shortMonths(o).indexOf(g[s.shortMonth]) : s.longMonth && (w = P.longMonths(o).indexOf(g[s.longMonth]));
          const h = Number(g[s.day]) || 1, v = Number(g[s.hour]);
          let D = Number.isNaN(v) ? 0 : v;
          const S = Number(g[s.minute]), _ = Number.isNaN(S) ? 0 : S, j = Number(g[s.second]), R = Number.isNaN(j) ? 0 : j, q = g[s.ampm];
          return q && q === "PM" && (D += 12, D === 24 && (D = 0)), new Date(p, w, h, D, _, R, 0);
        }
      }
    }
    return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
  }
  static shortMonths(e) {
    return P.MONTH_JS.map((r) => new Date(2019, r).toLocaleString(e, { month: "short" }));
  }
  static longMonths(e) {
    return P.MONTH_JS.map((r) => new Date(2019, r).toLocaleString(e, { month: "long" }));
  }
  static formatPatterns(e, r) {
    switch (e) {
      case "YY":
      case "YYYY":
        return { group: "year", pattern: `(\\d{${e.length}})` };
      case "M":
        return { group: "month", pattern: "(\\d{1,2})" };
      case "MM":
        return { group: "month", pattern: "(\\d{2})" };
      case "MMM":
        return { group: "shortMonth", pattern: `(${P.shortMonths(r).join("|")})` };
      case "MMMM":
        return { group: "longMonth", pattern: `(${P.longMonths(r).join("|")})` };
      case "D":
        return { group: "day", pattern: "(\\d{1,2})" };
      case "DD":
        return { group: "day", pattern: "(\\d{2})" };
      case "h":
      case "H":
        return { group: "hour", pattern: "(\\d{1,2})" };
      case "hh":
      case "HH":
        return { group: "hour", pattern: "(\\d{2})" };
      case "m":
        return { group: "minute", pattern: "(\\d{1,2})" };
      case "mm":
        return { group: "minute", pattern: "(\\d{2})" };
      case "s":
        return { group: "second", pattern: "(\\d{1,2})" };
      case "ss":
        return { group: "second", pattern: "(\\d{2})" };
      case "a":
      case "A":
        return { group: "ampm", pattern: "(AM|PM|am|pm)" };
    }
  }
  getWeek(e) {
    const r = new Date(this.midnight_ts(this)), o = (this.getDay() + (7 - e)) % 7;
    r.setDate(r.getDate() - o);
    const i = r.getTime();
    return r.setMonth(0, 1), r.getDay() !== e && r.setMonth(0, 1 + (4 - r.getDay() + 7) % 7), 1 + Math.ceil((i - r.getTime()) / 6048e5);
  }
  clone() {
    return new P(this);
  }
  toJSDate() {
    return new Date(this);
  }
  inArray(e, r = "[]") {
    return e.some((o) => o instanceof Array ? this.isBetween(o[0], o[1], r) : this.isSame(o, "day"));
  }
  isBetween(e, r, o = "()") {
    switch (o) {
      default:
      case "()":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(r);
      case "[)":
        return this.midnight_ts(this) >= this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(r);
      case "(]":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) <= this.midnight_ts(r);
      case "[]":
        return this.midnight_ts() >= this.midnight_ts(e) && this.midnight_ts() <= this.midnight_ts(r);
    }
  }
  isBefore(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
      case "year":
      case "years":
        return e.getFullYear() > this.getFullYear();
    }
    throw new Error("isBefore: Invalid unit!");
  }
  isSameOrBefore(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrBefore: Invalid unit!");
  }
  isAfter(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(e.getFullYear(), e.getMonth(), 1).getTime();
      case "year":
      case "years":
        return this.getFullYear() > e.getFullYear();
    }
    throw new Error("isAfter: Invalid unit!");
  }
  isSameOrAfter(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrAfter: Invalid unit!");
  }
  isSame(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSame: Invalid unit!");
  }
  add(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        this.setDate(this.getDate() + e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() + e);
    }
    return this;
  }
  subtract(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        this.setDate(this.getDate() - e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() - e);
    }
    return this;
  }
  diff(e, r = "days") {
    switch (r) {
      default:
      case "day":
      case "days":
        return Math.round((this.midnight_ts() - this.midnight_ts(e)) / 864e5);
      case "month":
      case "months":
        let o = 12 * (e.getFullYear() - this.getFullYear());
        return o -= e.getMonth(), o += this.getMonth(), o;
    }
  }
  format(e, r = "en-US") {
    let o = "";
    const i = [];
    let l = null;
    for (; (l = P.regex.exec(e)) != null; )
      l[1] !== "\\" && i.push(l);
    if (i.length) {
      i[0].index > 0 && (o += e.substring(0, i[0].index));
      for (const [s, c] of Object.entries(i)) {
        const g = Number(s);
        o += this.formatTokens(c[0], r), i[g + 1] && (o += e.substring(c.index + c[0].length, i[g + 1].index)), g === i.length - 1 && (o += e.substring(c.index + c[0].length));
      }
    }
    return o.replace(/\\/g, "");
  }
  midnight_ts(e) {
    return e ? new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
  }
  formatTokens(e, r) {
    switch (e) {
      case "YY":
        return String(this.getFullYear()).slice(-2);
      case "YYYY":
        return String(this.getFullYear());
      case "M":
        return String(this.getMonth() + 1);
      case "MM":
        return `0${this.getMonth() + 1}`.slice(-2);
      case "MMM":
        return P.shortMonths(r)[this.getMonth()];
      case "MMMM":
        return P.longMonths(r)[this.getMonth()];
      case "D":
        return String(this.getDate());
      case "DD":
        return `0${this.getDate()}`.slice(-2);
      case "H":
        return String(this.getHours());
      case "HH":
        return `0${this.getHours()}`.slice(-2);
      case "h":
        return String(this.getHours() % 12 || 12);
      case "hh":
        return `0${this.getHours() % 12 || 12}`.slice(-2);
      case "m":
        return String(this.getMinutes());
      case "mm":
        return `0${this.getMinutes()}`.slice(-2);
      case "s":
        return String(this.getSeconds());
      case "ss":
        return `0${this.getSeconds()}`.slice(-2);
      case "a":
        return this.getHours() < 12 || this.getHours() === 24 ? "am" : "pm";
      case "A":
        return this.getHours() < 12 || this.getHours() === 24 ? "AM" : "PM";
      default:
        return "";
    }
  }
}, E(P, "regex", /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g), E(P, "MONTH_JS", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]), P);
class Ft {
  constructor(t) {
    E(this, "picker");
    this.picker = t;
  }
  render(t, e) {
    t || (t = new k()), t.setDate(1), t.setHours(0, 0, 0, 0), typeof this[`get${e}View`] == "function" && this[`get${e}View`](t);
  }
  getContainerView(t) {
    this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", { date: t.clone(), view: "Header" }), this.picker.trigger("render", { date: t.clone(), view: "Main" }), this.picker.options.autoApply || this.picker.trigger("render", { date: t.clone(), view: "Footer" });
  }
  getHeaderView(t) {
    const e = document.createElement("header");
    this.picker.options.header instanceof HTMLElement && e.appendChild(this.picker.options.header), typeof this.picker.options.header == "string" && (e.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { target: e, date: t.clone(), view: "Header" });
  }
  getMainView(t) {
    const e = document.createElement("main");
    this.picker.ui.container.appendChild(e);
    const r = document.createElement("div");
    r.className = `calendars grid-${this.picker.options.grid}`;
    for (let o = 0; o < this.picker.options.calendars; o++) {
      const i = document.createElement("div");
      i.className = "calendar", r.appendChild(i);
      const l = this.getCalendarHeaderView(t.clone());
      i.appendChild(l), this.picker.trigger("view", { date: t.clone(), view: "CalendarHeader", index: o, target: l });
      const s = this.getCalendarDayNamesView();
      i.appendChild(s), this.picker.trigger("view", { date: t.clone(), view: "CalendarDayNames", index: o, target: s });
      const c = this.getCalendarDaysView(t.clone());
      i.appendChild(c), this.picker.trigger("view", { date: t.clone(), view: "CalendarDays", index: o, target: c });
      const g = this.getCalendarFooterView(this.picker.options.lang, t.clone());
      i.appendChild(g), this.picker.trigger("view", { date: t.clone(), view: "CalendarFooter", index: o, target: g }), this.picker.trigger("view", { date: t.clone(), view: "CalendarItem", index: o, target: i }), t.add(1, "month");
    }
    e.appendChild(r), this.picker.trigger("view", { date: t.clone(), view: "Calendars", target: r }), this.picker.trigger("view", { date: t.clone(), view: "Main", target: e });
  }
  getFooterView(t) {
    const e = document.createElement("footer"), r = document.createElement("div");
    r.className = "footer-buttons";
    const o = document.createElement("button");
    o.className = "cancel-button unit", o.innerHTML = this.picker.options.locale.cancel, r.appendChild(o);
    const i = document.createElement("button");
    i.className = "apply-button unit", i.innerHTML = this.picker.options.locale.apply, i.disabled = !0, r.appendChild(i), e.appendChild(r), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { date: t, target: e, view: "Footer" });
  }
  getCalendarHeaderView(t) {
    const e = document.createElement("div");
    e.className = "header";
    const r = document.createElement("div");
    r.className = "month-name", r.innerHTML = `<span>${t.toLocaleString(this.picker.options.lang, { month: "long" })}</span> ${t.format("YYYY")}`, e.appendChild(r);
    const o = document.createElement("button");
    o.className = "previous-button unit", o.innerHTML = this.picker.options.locale.previousMonth, e.appendChild(o);
    const i = document.createElement("button");
    return i.className = "next-button unit", i.innerHTML = this.picker.options.locale.nextMonth, e.appendChild(i), e;
  }
  getCalendarDayNamesView() {
    const t = document.createElement("div");
    t.className = "daynames-row";
    for (let e = 1; e <= 7; e++) {
      const r = 3 + this.picker.options.firstDay + e, o = document.createElement("div");
      o.className = "dayname", o.innerHTML = new Date(1970, 0, r, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "short" }), o.title = new Date(1970, 0, r, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "long" }), t.appendChild(o), this.picker.trigger("view", { dayIdx: r, view: "CalendarDayName", target: o });
    }
    return t;
  }
  getCalendarDaysView(t) {
    const e = document.createElement("div");
    e.className = "days-grid";
    const r = this.calcOffsetDays(t, this.picker.options.firstDay), o = 32 - new Date(t.getFullYear(), t.getMonth(), 32).getDate();
    for (let i = 0; i < r; i++) {
      const l = document.createElement("div");
      l.className = "offset", e.appendChild(l);
    }
    for (let i = 1; i <= o; i++) {
      t.setDate(i);
      const l = this.getCalendarDayView(t);
      e.appendChild(l), this.picker.trigger("view", { date: t, view: "CalendarDay", target: l });
    }
    return e;
  }
  getCalendarDayView(t) {
    const e = this.picker.options.date ? new k(this.picker.options.date) : null, r = new k(), o = document.createElement("div");
    return o.className = "day unit", o.innerHTML = t.format("D"), o.dataset.time = String(t.getTime()), t.isSame(r, "day") && o.classList.add("today"), [0, 6].includes(t.getDay()) && o.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(t, "day") && o.classList.add("selected") : e && t.isSame(e, "day") && o.classList.add("selected"), this.picker.trigger("view", { date: t, view: "CalendarDay", target: o }), o;
  }
  getCalendarFooterView(t, e) {
    const r = document.createElement("div");
    return r.className = "footer", r;
  }
  calcOffsetDays(t, e) {
    let r = t.getDay() - e;
    return r < 0 && (r += 7), r;
  }
}
let It = class {
  constructor(t) {
    E(this, "picker");
    E(this, "instances", {});
    this.picker = t;
  }
  initialize() {
    const t = [];
    this.picker.options.plugins.forEach((e) => {
      typeof e == "function" ? t.push(new e()) : typeof e == "string" && typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, e) ? t.push(new easepick[e]()) : console.warn(`easepick: ${e} not found.`);
    }), t.sort((e, r) => e.priority > r.priority ? -1 : e.priority < r.priority || e.dependencies.length > r.dependencies.length ? 1 : e.dependencies.length < r.dependencies.length ? -1 : 0), t.forEach((e) => {
      e.attach(this.picker), this.instances[e.getName()] = e;
    });
  }
  getInstance(t) {
    return this.instances[t];
  }
  addInstance(t) {
    if (Object.prototype.hasOwnProperty.call(this.instances, t))
      console.warn(`easepick: ${t} already added.`);
    else {
      if (typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, t)) {
        const e = new easepick[t]();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      if (this.getPluginFn(t) !== "undefined") {
        const e = new (this.getPluginFn(t))();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      console.warn(`easepick: ${t} not found.`);
    }
    return null;
  }
  removeInstance(t) {
    return t in this.instances && this.instances[t].detach(), delete this.instances[t];
  }
  reloadInstance(t) {
    return this.removeInstance(t), this.addInstance(t);
  }
  getPluginFn(t) {
    return [...this.picker.options.plugins].filter((e) => typeof e == "function" && new e().getName() === t).shift();
  }
};
class $e {
  constructor(t) {
    E(this, "Calendar", new Ft(this));
    E(this, "PluginManager", new It(this));
    E(this, "calendars", []);
    E(this, "datePicked", []);
    E(this, "cssLoaded", 0);
    E(this, "binds", { hidePicker: this.hidePicker.bind(this), show: this.show.bind(this) });
    E(this, "options", { doc: document, css: [], element: null, firstDay: 1, grid: 1, calendars: 1, lang: "en-US", date: null, format: "YYYY-MM-DD", readonly: !0, autoApply: !0, header: !1, inline: !1, scrollToDate: !0, locale: { nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>', previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>', cancel: "Cancel", apply: "Apply" }, documentClick: this.binds.hidePicker, plugins: [] });
    E(this, "ui", { container: null, shadowRoot: null, wrapper: null });
    E(this, "version", "1.2.1");
    const e = { ...this.options.locale, ...t.locale };
    this.options = { ...this.options, ...t }, this.options.locale = e, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({ mode: "open" }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), typeof this.options.setup == "function" && this.options.setup(this), this.on("click", this.onClick.bind(this));
    const r = this.options.scrollToDate ? this.getDate() : null;
    this.renderAll(r);
  }
  on(t, e, r = {}) {
    this.ui.container.addEventListener(t, e, r);
  }
  off(t, e, r = {}) {
    this.ui.container.removeEventListener(t, e, r);
  }
  trigger(t, e = {}) {
    return this.ui.container.dispatchEvent(new CustomEvent(t, { detail: e }));
  }
  destroy() {
    this.options.element.removeEventListener("click", this.binds.show), typeof this.options.documentClick == "function" && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach((t) => {
      this.PluginManager.removeInstance(t);
    }), this.ui.wrapper.remove();
  }
  onRender(t) {
    const { view: e, date: r } = t.detail;
    this.Calendar.render(r, e);
  }
  onView(t) {
    const { view: e, target: r } = t.detail;
    e === "Footer" && this.datePicked.length && (r.querySelector(".apply-button").disabled = !1);
  }
  onClickHeaderButton(t) {
    this.isCalendarHeaderButton(t) && (t.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
  }
  onClickCalendarDay(t) {
    if (this.isCalendarDay(t)) {
      const e = new k(t.dataset.time);
      this.options.autoApply ? (this.setDate(e), this.trigger("select", { date: this.getDate() }), this.hide()) : (this.datePicked[0] = e, this.trigger("preselect", { date: this.getDate() }), this.renderAll());
    }
  }
  onClickApplyButton(t) {
    if (this.isApplyButton(t)) {
      if (this.datePicked[0] instanceof Date) {
        const e = this.datePicked[0].clone();
        this.setDate(e);
      }
      this.hide(), this.trigger("select", { date: this.getDate() });
    }
  }
  onClickCancelButton(t) {
    this.isCancelButton(t) && this.hide();
  }
  onClick(t) {
    const e = t.target;
    if (e instanceof HTMLElement) {
      const r = e.closest(".unit");
      if (!(r instanceof HTMLElement))
        return;
      this.onClickHeaderButton(r), this.onClickCalendarDay(r), this.onClickApplyButton(r), this.onClickCancelButton(r);
    }
  }
  isShown() {
    return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
  }
  show(t) {
    if (this.isShown())
      return;
    const e = t && "target" in t ? t.target : this.options.element, { top: r, left: o } = this.adjustPosition(e);
    this.ui.container.style.top = `${r}px`, this.ui.container.style.left = `${o}px`, this.ui.container.classList.add("show"), this.trigger("show", { target: e });
  }
  hide() {
    this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
  }
  setDate(t) {
    const e = new k(t, this.options.format);
    this.options.date = e.clone(), this.updateValues(), this.calendars.length && this.renderAll();
  }
  getDate() {
    return this.options.date instanceof k ? this.options.date.clone() : null;
  }
  parseValues() {
    this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
  }
  updateValues() {
    const t = this.getDate(), e = t instanceof Date ? t.format(this.options.format, this.options.lang) : "", r = this.options.element;
    r instanceof HTMLInputElement ? r.value = e : r instanceof HTMLElement && (r.innerText = e);
  }
  hidePicker(t) {
    let e = t.target, r = null;
    e.shadowRoot && (e = t.composedPath()[0], r = e.getRootNode().host), this.isShown() && r !== this.ui.wrapper && e !== this.options.element && this.hide();
  }
  renderAll(t) {
    this.trigger("render", { view: "Container", date: (t || this.calendars[0]).clone() });
  }
  isCalendarHeaderButton(t) {
    return ["previous-button", "next-button"].some((e) => t.classList.contains(e));
  }
  isCalendarDay(t) {
    return t.classList.contains("day");
  }
  isApplyButton(t) {
    return t.classList.contains("apply-button");
  }
  isCancelButton(t) {
    return t.classList.contains("cancel-button");
  }
  gotoDate(t) {
    const e = new k(t, this.options.format);
    e.setDate(1), this.calendars[0] = e.clone(), this.renderAll();
  }
  clear() {
    this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
  }
  handleOptions() {
    this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new k(this.options.date, this.options.format) : this.calendars[0] = new k();
  }
  handleCSS() {
    if (Array.isArray(this.options.css))
      this.options.css.forEach((t) => {
        const e = document.createElement("link");
        e.href = t, e.rel = "stylesheet";
        const r = () => {
          this.cssLoaded++, this.cssLoaded === this.options.css.length && (this.ui.wrapper.style.display = "");
        };
        e.addEventListener("load", r), e.addEventListener("error", r), this.ui.shadowRoot.append(e);
      });
    else if (typeof this.options.css == "string") {
      const t = document.createElement("style"), e = document.createTextNode(this.options.css);
      t.appendChild(e), this.ui.shadowRoot.append(t), this.ui.wrapper.style.display = "";
    } else
      typeof this.options.css == "function" && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
  }
  adjustPosition(t) {
    const e = t.getBoundingClientRect(), r = this.ui.wrapper.getBoundingClientRect();
    this.ui.container.classList.add("calc");
    const o = this.ui.container.getBoundingClientRect();
    this.ui.container.classList.remove("calc");
    let i = e.bottom - r.bottom, l = e.left - r.left;
    return typeof window < "u" && (window.innerHeight < i + o.height && i - o.height >= 0 && (i = e.top - r.top - o.height), window.innerWidth < l + o.width && e.right - o.width >= 0 && (l = e.right - r.right - o.width)), { left: l, top: i };
  }
}
var he = Object.freeze({ __proto__: null, Core: $e, create: $e });
class Xe {
  constructor() {
    E(this, "picker");
    E(this, "options");
    E(this, "priority", 0);
    E(this, "dependencies", []);
  }
  attach(t) {
    const e = this.getName(), r = { ...this.options };
    this.options = { ...this.options, ...t.options[e] || {} };
    for (const i of Object.keys(r))
      if (r[i] !== null && typeof r[i] == "object" && Object.keys(r[i]).length && e in t.options && i in t.options[e]) {
        const l = { ...t.options[e][i] };
        l !== null && typeof l == "object" && Object.keys(l).length && Object.keys(l).every((s) => Object.keys(r[i]).includes(s)) && (this.options[i] = { ...r[i], ...l });
      }
    if (this.picker = t, this.dependenciesNotFound()) {
      const i = this.dependencies.filter((l) => !this.pluginsAsStringArray().includes(l));
      return void console.warn(`${this.getName()}: required dependencies (${i.join(", ")}).`);
    }
    const o = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.add(o), this.onAttach();
  }
  detach() {
    const t = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.remove(t), typeof this.onDetach == "function" && this.onDetach();
  }
  dependenciesNotFound() {
    return this.dependencies.length && !this.dependencies.every((t) => this.pluginsAsStringArray().includes(t));
  }
  pluginsAsStringArray() {
    return this.picker.options.plugins.map((t) => typeof t == "function" ? new t().getName() : t);
  }
  camelCaseToKebab(t) {
    return t.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
  }
}
class fe extends Xe {
  constructor() {
    super(...arguments);
    E(this, "priority", 1);
    E(this, "binds", { onView: this.onView.bind(this) });
    E(this, "options", { minDate: null, maxDate: null, minDays: null, maxDays: null, selectForward: null, selectBackward: null, presets: !0, inseparable: !1, filter: null });
  }
  getName() {
    return "LockPlugin";
  }
  onAttach() {
    if (this.options.minDate && (this.options.minDate = new k(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new k(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof k && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
      const e = this.picker.calendars[0].clone().subtract(1, "month");
      this.picker.gotoDate(e);
    }
    if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
      const e = ["minDays", "maxDays", "selectForward", "selectBackward"];
      console.warn(`${this.getName()}: options ${e.join(", ")} required RangePlugin.`);
    }
    this.picker.on("view", this.binds.onView);
  }
  onDetach() {
    this.picker.off("view", this.binds.onView);
  }
  onView(e) {
    const { view: r, target: o, date: i } = e.detail;
    if (r === "CalendarHeader" && (this.options.minDate instanceof k && i.isSameOrBefore(this.options.minDate, "month") && o.classList.add("no-previous-month"), this.options.maxDate instanceof k && i.isSameOrAfter(this.options.maxDate, "month") && o.classList.add("no-next-month")), r === "CalendarDay") {
      const l = this.picker.datePicked.length ? this.picker.datePicked[0] : null;
      if (this.testFilter(i))
        return void o.classList.add("locked");
      if (this.options.inseparable) {
        if (this.options.minDays) {
          const s = i.clone().subtract(this.options.minDays - 1, "day"), c = i.clone().add(this.options.minDays - 1, "day");
          let g = !1, p = !1;
          for (; s.isBefore(i, "day"); ) {
            if (this.testFilter(s)) {
              g = !0;
              break;
            }
            s.add(1, "day");
          }
          for (; c.isAfter(i, "day"); ) {
            if (this.testFilter(c)) {
              p = !0;
              break;
            }
            c.subtract(1, "day");
          }
          g && p && o.classList.add("not-available");
        }
        this.rangeIsNotAvailable(i, l) && o.classList.add("not-available");
      }
      this.dateIsNotAvailable(i, l) && o.classList.add("not-available");
    }
    if (this.options.presets && r === "PresetPluginButton") {
      const l = new k(Number(o.dataset.start)), s = new k(Number(o.dataset.end)), c = s.diff(l, "day"), g = this.options.minDays && c < this.options.minDays, p = this.options.maxDays && c > this.options.maxDays;
      (g || p || this.lockMinDate(l) || this.lockMaxDate(l) || this.lockMinDate(s) || this.lockMaxDate(s) || this.rangeIsNotAvailable(l, s)) && o.setAttribute("disabled", "disabled");
    }
  }
  dateIsNotAvailable(e, r) {
    return this.lockMinDate(e) || this.lockMaxDate(e) || this.lockMinDays(e, r) || this.lockMaxDays(e, r) || this.lockSelectForward(e) || this.lockSelectBackward(e);
  }
  rangeIsNotAvailable(e, r) {
    if (!e || !r)
      return !1;
    const o = (e.isSameOrBefore(r, "day") ? e : r).clone(), i = (r.isSameOrAfter(e, "day") ? r : e).clone();
    for (; o.isSameOrBefore(i, "day"); ) {
      if (this.testFilter(o))
        return !0;
      o.add(1, "day");
    }
    return !1;
  }
  lockMinDate(e) {
    return this.options.minDate instanceof k && e.isBefore(this.options.minDate, "day");
  }
  lockMaxDate(e) {
    return this.options.maxDate instanceof k && e.isAfter(this.options.maxDate, "day");
  }
  lockMinDays(e, r) {
    if (this.options.minDays && r) {
      const o = r.clone().subtract(this.options.minDays - 1, "day"), i = r.clone().add(this.options.minDays - 1, "day");
      return e.isBetween(o, i);
    }
    return !1;
  }
  lockMaxDays(e, r) {
    if (this.options.maxDays && r) {
      const o = r.clone().subtract(this.options.maxDays, "day"), i = r.clone().add(this.options.maxDays, "day");
      return !e.isBetween(o, i);
    }
    return !1;
  }
  lockSelectForward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectForward) {
      const r = this.picker.datePicked[0].clone();
      return e.isBefore(r, "day");
    }
    return !1;
  }
  lockSelectBackward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectBackward) {
      const r = this.picker.datePicked[0].clone();
      return e.isAfter(r, "day");
    }
    return !1;
  }
  testFilter(e) {
    return typeof this.options.filter == "function" && this.options.filter(e, this.picker.datePicked);
  }
}
class Bt extends Xe {
  constructor() {
    super(...arguments);
    E(this, "tooltipElement");
    E(this, "triggerElement");
    E(this, "binds", { setStartDate: this.setStartDate.bind(this), setEndDate: this.setEndDate.bind(this), setDateRange: this.setDateRange.bind(this), getStartDate: this.getStartDate.bind(this), getEndDate: this.getEndDate.bind(this), onView: this.onView.bind(this), onShow: this.onShow.bind(this), onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClickCalendarDay: this.onClickCalendarDay.bind(this), onClickApplyButton: this.onClickApplyButton.bind(this), parseValues: this.parseValues.bind(this), updateValues: this.updateValues.bind(this), clear: this.clear.bind(this) });
    E(this, "options", { elementEnd: null, startDate: null, endDate: null, repick: !1, strict: !0, delimiter: " - ", tooltip: !0, tooltipNumber: (e) => e, locale: { zero: "", one: "day", two: "", few: "", many: "", other: "days" }, documentClick: this.hidePicker.bind(this) });
  }
  getName() {
    return "RangePlugin";
  }
  onAttach() {
    this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds.setStartDate }, setEndDate: { configurable: !0, value: this.binds.setEndDate }, setDateRange: { configurable: !0, value: this.binds.setDateRange }, getStartDate: { configurable: !0, value: this.binds.getStartDate }, getEndDate: { configurable: !0, value: this.binds.getEndDate }, parseValues: { configurable: !0, value: this.binds.parseValues }, updateValues: { configurable: !0, value: this.binds.updateValues }, clear: { configurable: !0, value: this.binds.clear }, onClickCalendarDay: { configurable: !0, value: this.binds.onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds.onClickApplyButton } }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), typeof this.picker.options.documentClick == "function" && (document.removeEventListener("click", this.picker.options.documentClick, !0), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
  }
  onDetach() {
    Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds._setStartDate }, setEndDate: { configurable: !0, value: this.binds._setEndDate }, setDateRange: { configurable: !0, value: this.binds._setDateRange }, getStartDate: { configurable: !0, value: this.binds._getStartDate }, getEndDate: { configurable: !0, value: this.binds._getEndDate }, parseValues: { configurable: !0, value: this.binds._parseValues }, updateValues: { configurable: !0, value: this.binds._updateValues }, clear: { configurable: !0, value: this.binds._clear }, onClickCalendarDay: { configurable: !0, value: this.binds._onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds._onClickApplyButton } }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
  }
  parseValues() {
    if (this.options.startDate || this.options.endDate)
      this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));
    else if (this.options.elementEnd)
      this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));
    else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
      const [e, r] = this.picker.options.element.value.split(this.options.delimiter);
      this.options.strict ? e && r && this.setDateRange(e, r) : (e && this.setStartDate(e), r && this.setEndDate(r));
    }
  }
  updateValues() {
    const e = this.picker.options.element, r = this.options.elementEnd, o = this.picker.getStartDate(), i = this.picker.getEndDate(), l = o instanceof Date ? o.format(this.picker.options.format, this.picker.options.lang) : "", s = i instanceof Date ? i.format(this.picker.options.format, this.picker.options.lang) : "";
    if (r)
      e instanceof HTMLInputElement ? e.value = l : e instanceof HTMLElement && (e.innerText = l), r instanceof HTMLInputElement ? r.value = s : r instanceof HTMLElement && (r.innerText = s);
    else {
      const c = `${l}${l || s ? this.options.delimiter : ""}${s}`;
      e instanceof HTMLInputElement ? e.value = c : e instanceof HTMLElement && (e.innerText = c);
    }
  }
  clear() {
    this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
  }
  onShow(e) {
    const { target: r } = e.detail;
    this.triggerElement = r, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
  }
  onView(e) {
    const { view: r, target: o } = e.detail;
    if (r === "Main" && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", o.appendChild(this.tooltipElement)), r === "CalendarDay") {
      const i = new k(o.dataset.time), l = this.picker.datePicked, s = l.length ? this.picker.datePicked[0] : this.getStartDate(), c = l.length ? this.picker.datePicked[1] : this.getEndDate();
      s && s.isSame(i, "day") && o.classList.add("start"), s && c && (c.isSame(i, "day") && o.classList.add("end"), i.isBetween(s, c) && o.classList.add("in-range"));
    }
    if (r === "Footer") {
      const i = this.picker.datePicked.length === 1 && !this.options.strict || this.picker.datePicked.length === 2;
      o.querySelector(".apply-button").disabled = !i;
    }
  }
  hidePicker(e) {
    let r = e.target, o = null;
    r.shadowRoot && (r = e.composedPath()[0], o = r.getRootNode().host), this.picker.isShown() && o !== this.picker.ui.wrapper && r !== this.picker.options.element && r !== this.options.elementEnd && this.picker.hide();
  }
  setStartDate(e) {
    const r = new k(e, this.picker.options.format);
    this.options.startDate = r ? r.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setEndDate(e) {
    const r = new k(e, this.picker.options.format);
    this.options.endDate = r ? r.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setDateRange(e, r) {
    const o = new k(e, this.picker.options.format), i = new k(r, this.picker.options.format);
    this.options.startDate = o ? o.clone() : null, this.options.endDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  getStartDate() {
    return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
  }
  getEndDate() {
    return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
  }
  onMouseEnter(e) {
    const r = e.target;
    if (r instanceof HTMLElement) {
      this.isContainer(r) && this.initializeRepick();
      const o = r.closest(".unit");
      if (!(o instanceof HTMLElement))
        return;
      if (this.picker.isCalendarDay(o)) {
        if (this.picker.datePicked.length !== 1)
          return;
        let i = this.picker.datePicked[0].clone(), l = new k(o.dataset.time), s = !1;
        if (i.isAfter(l, "day")) {
          const c = i.clone();
          i = l.clone(), l = c.clone(), s = !0;
        }
        if ([...this.picker.ui.container.querySelectorAll(".day")].forEach((c) => {
          const g = new k(c.dataset.time), p = this.picker.Calendar.getCalendarDayView(g);
          g.isBetween(i, l) && p.classList.add("in-range"), g.isSame(this.picker.datePicked[0], "day") && (p.classList.add("start"), p.classList.toggle("flipped", s)), c === o && (p.classList.add("end"), p.classList.toggle("flipped", s)), c.className = p.className;
        }), this.options.tooltip) {
          const c = this.options.tooltipNumber(l.diff(i, "day") + 1);
          if (c > 0) {
            const g = new Intl.PluralRules(this.picker.options.lang).select(c), p = `${c} ${this.options.locale[g]}`;
            this.showTooltip(o, p);
          } else
            this.hideTooltip();
        }
      }
    }
  }
  onMouseLeave(e) {
    if (this.isContainer(e.target) && this.options.repick) {
      const r = this.getStartDate(), o = this.getEndDate();
      r && o && (this.picker.datePicked.length = 0, this.picker.renderAll());
    }
  }
  onClickCalendarDay(e) {
    if (this.picker.isCalendarDay(e)) {
      this.picker.datePicked.length === 2 && (this.picker.datePicked.length = 0);
      const r = new k(e.dataset.time);
      if (this.picker.datePicked[this.picker.datePicked.length] = r, this.picker.datePicked.length === 2 && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
        const o = this.picker.datePicked[1].clone();
        this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = o.clone();
      }
      this.picker.datePicked.length !== 1 && this.picker.options.autoApply || this.picker.trigger("preselect", { start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null, end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null }), this.picker.datePicked.length === 1 && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() })), this.picker.renderAll()), this.picker.datePicked.length === 2 && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
    }
  }
  onClickApplyButton(e) {
    this.picker.isApplyButton(e) && (this.picker.datePicked.length !== 1 || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), this.picker.datePicked.length === 2 && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide());
  }
  showTooltip(e, r) {
    this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = r;
    const o = this.picker.ui.container.getBoundingClientRect(), i = this.tooltipElement.getBoundingClientRect(), l = e.getBoundingClientRect();
    let s = l.top, c = l.left;
    s -= o.top, c -= o.left, s -= i.height, c -= i.width / 2, c += l.width / 2, this.tooltipElement.style.top = `${s}px`, this.tooltipElement.style.left = `${c}px`;
  }
  hideTooltip() {
    this.tooltipElement.style.visibility = "hidden";
  }
  checkIntlPluralLocales() {
    if (!this.options.tooltip)
      return;
    const e = [.../* @__PURE__ */ new Set([new Intl.PluralRules(this.picker.options.lang).select(0), new Intl.PluralRules(this.picker.options.lang).select(1), new Intl.PluralRules(this.picker.options.lang).select(2), new Intl.PluralRules(this.picker.options.lang).select(6), new Intl.PluralRules(this.picker.options.lang).select(18)])], r = Object.keys(this.options.locale);
    e.every((o) => r.includes(o)) || console.warn(`${this.getName()}: provide locales (${e.join(", ")}) for correct tooltip text.`);
  }
  initializeRepick() {
    if (!this.options.repick)
      return;
    const e = this.getStartDate(), r = this.getEndDate();
    r && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = r), e && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = e);
  }
  isContainer(e) {
    return e === this.picker.ui.container;
  }
}
function zt(n) {
  const t = M.useRef(null), [e] = M.useState(() => Math.ceil(Math.random() * 1e3)), r = M.useCallback(function(s) {
    if (!s.target)
      return;
    const c = s.target;
    if (c.classList.contains("day") && !c.classList.contains("locked") && !c.classList.contains("not-available")) {
      const g = c.getAttribute("data-time"), p = new Date(Number(g));
      n({
        start: p,
        end: p
      }), t.current && (t.current.setStartDate(p), t.current.setEndDate(p));
    }
  }, []), o = M.useCallback(function(s) {
    const {
      detail: { start: c, end: g }
    } = s;
    n({
      start: c,
      end: g
    });
  }, []), i = M.useCallback(function(s) {
    if (!t.current)
      return;
    const c = t.current.getStartDate(), g = t.current.getEndDate();
    if (c && g && g.isSame(c) && s.currentTarget) {
      const w = s.currentTarget.querySelector(
        `[data-time="${c.getTime()}"]`
      );
      w == null || w.classList.add("single-day");
    }
  }, []);
  return {
    onClick: r,
    onRender: i,
    onSelect: o,
    picker: t,
    startId: `start_${e}`,
    endId: `end_${e}`
  };
}
function $t(n, t) {
  return {
    formattedPeriod: M.useMemo(() => {
      if (!t)
        return "";
      const { start: r, end: o } = t, i = Intl.DateTimeFormat(n, {
        day: "numeric",
        month: "short"
      }), l = i.format(r);
      return Nt(r, o) ? l : `${l} - ${i.format(o)}`;
    }, [n, t])
  };
}
const Ht = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars .calendar:nth-child(n+2){display:block}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar{padding:8px}.calendar>.header{padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{padding:0;border:none;border-radius:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1)}.calendar>.header .previous-button,.calendar>.header .next-button{display:none}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row{display:none}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}@media (min-width: 992px){.calendars{padding:40px 16px 24px;grid-template-columns:repeat(2,1fr)}.calendars .calendar>.daynames-row{display:grid}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button{display:flex;position:absolute;top:5px}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button>svg,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button>svg{height:24px;width:auto}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:first-child>.header .previous-button{left:0}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar:nth-child(2)>.header .next-button{right:0}.calendars .calendar{padding:8px 24px}.calendars .calendar:nth-child(n+3){display:none}}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}', Vt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars{padding:24px 0 16px}@media (max-width: 480px){.calendars{padding:8px 0}}.calendars .calendar:nth-child(n+2){display:none}@media (min-width: 992px){.calendars .calendar:nth-child(n+2){display:block}}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}.calendars.grid-2{grid-template-columns:none}@media (min-width: 992px){.calendars{padding:32px 16px 24px}.calendars.grid-2{grid-template-columns:repeat(2,1fr)}.calendars:not(.grid-1) .calendar>.header .next-button{visibility:hidden}}.calendar{padding:8px 24px}@media (max-width: 480px){.calendar{padding:8px}}.calendar>.header{position:relative;padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{position:absolute;top:5px;padding:0;border:none;border-radius:0}.calendar>.header button.previous-button{left:0}.calendar>.header button.next-button{right:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1);height:24px;width:auto}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.inline{min-height:unset}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}';
var te = /* @__PURE__ */ ((n) => (n[n.DISABLED = 0] = "DISABLED", n[n.ENABLED = 1] = "ENABLED", n[n.ONLY_HALF_DAY = 2] = "ONLY_HALF_DAY", n))(te || {}), I = /* @__PURE__ */ ((n) => (n.ALL_DAY = "day", n.MORNING = "morning", n.AFTERNOON = "afternoon", n.ALL_SEASON = "season", n))(I || {});
function Wt(n) {
  if (!n.settings.bookingSeasonal && n.settings.bookingHalfDay === te.DISABLED)
    return null;
  const t = n.dayDifference === 1 && n.settings.bookingHalfDay !== te.DISABLED;
  return /* @__PURE__ */ y.jsxs("div", { className: "space-y-4 mb-4", children: [
    t ? /* @__PURE__ */ y.jsxs("div", { className: "grid grid-cols-3 gap-2 sm:gap-4", children: [
      /* @__PURE__ */ y.jsx(
        Q,
        {
          label: n.labels.all_day,
          onClick: () => {
            n.onButtonClick(I.ALL_DAY);
          },
          active: n.selectedBookingPeriod === I.ALL_DAY
        }
      ),
      /* @__PURE__ */ y.jsx(
        Q,
        {
          label: n.labels.morning,
          onClick: () => {
            n.onButtonClick(I.MORNING);
          },
          active: n.selectedBookingPeriod === I.MORNING
        }
      ),
      /* @__PURE__ */ y.jsx(
        Q,
        {
          label: n.labels.afternoon,
          onClick: () => {
            n.onButtonClick(I.AFTERNOON);
          },
          active: n.selectedBookingPeriod === I.AFTERNOON
        }
      )
    ] }) : null,
    n.settings.bookingSeasonal ? /* @__PURE__ */ y.jsx(
      Q,
      {
        label: n.labels.all_season,
        onClick: () => {
          n.onButtonClick(I.ALL_SEASON);
        }
      }
    ) : null
  ] });
}
function Q(n) {
  return /* @__PURE__ */ y.jsx(
    "button",
    {
      type: "button",
      className: ge(
        "block w-full select-none rounded-sm border border-gray-300 bg-white p-2 text-center text-sm text-primary transition-colors hover:border-blue-500 hover:bg-blue-100 hover:text-blue-500 sm:px-3",
        n.className,
        { "bg-blue-100 text-blue-500 border-blue-500": n.active }
      ),
      onClick: n.onClick,
      children: n.label
    }
  );
}
const Ut = [
  new Date(2024, 0, 1),
  // monday
  new Date(2024, 0, 2),
  // tuesday
  new Date(2024, 0, 3),
  // wednesday
  new Date(2024, 0, 4),
  // thursday
  new Date(2024, 0, 5),
  // friday
  new Date(2024, 0, 6),
  // saturday
  new Date(2024, 0, 7)
  // sunday
];
function Qe(n) {
  const t = Intl.DateTimeFormat(n.locale, {
    weekday: "short"
  }), e = Intl.DateTimeFormat(n.locale, {
    weekday: "long"
  }), r = Ut.map((o) => ({
    label: t.format(o),
    title: e.format(o)
  }));
  return /* @__PURE__ */ y.jsx("div", { className: "mx-auto my-2 grid w-full max-w-xs grid-cols-7 lg:hidden", children: r.map(({ title: o, label: i }) => /* @__PURE__ */ y.jsx(
    "div",
    {
      className: "text-center text-sm capitalize text-secondary",
      title: o,
      children: i
    },
    o
  )) });
}
function qt(n) {
  if (!n)
    return 0;
  const t = O.fromJSDate(n.start), e = O.fromJSDate(n.end);
  return Math.floor(e.diff(t, ["days"]).days + 1);
}
function Jt(n, t = !1) {
  return t || !n ? 2 : Math.max(
    Ot({
      start: n.minDate,
      end: n.maxDate
    }),
    2
  );
}
function Gt(n, t) {
  const e = n ? Vt : Ht;
  return t === "portal" ? `${e}
:host {
  --color-bg-secondary: var(--gray-50, #ebeef1);
  --color-bg-inrange: var(--gray-50, #ebeef1);

  --color-fg-default: var(--gray-900, #1a1b25);
  --color-fg-primary: var(--blue-300, #00b0ff);
  --color-fg-secondary: var(--gray-300, #d4d9df);

  --color-fg-muted: var(--gray-500, #677284); /*  */

  --day-width: 48px;
  --day-height: 48px;
  --border-radius: 4px;
}` : e;
}
function or(n) {
  const {
    settings: t = {
      bookingHalfDay: te.DISABLED,
      bookingSeasonal: !1
    }
  } = n, [e, r] = M.useState(n.period), { onClick: o, onRender: i, onSelect: l, picker: s, startId: c, endId: g } = zt(r), { formattedPeriod: p } = $t(n.lang, e), w = qt(e);
  return M.useEffect(() => {
    const h = document.getElementById(c), v = document.getElementById(g);
    if (!h || !v) {
      console.warn("cannot find startEl or endEl", h, v);
      return;
    }
    const D = e ? {
      startDate: e.start,
      endDate: e.end
    } : null;
    return s.current = new he.create({
      element: h,
      css: Gt(!!n.isWidget, n.mode),
      firstDay: 1,
      lang: n.lang,
      format: "YYYY-MM-DD",
      calendars: Jt(n.lockDates, n.isWidget),
      ...n.isWidget ? { grid: 2 } : {},
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [Bt, fe],
      RangePlugin: {
        elementEnd: v,
        tooltip: !1,
        ...D ? {
          startDate: new k(D.startDate),
          endDate: new k(D.endDate)
        } : {}
      },
      LockPlugin: {
        inseparable: !0,
        ...n.lockDates ? {
          minDate: n.lockDates.minDate,
          maxDate: n.lockDates.maxDate
        } : {},
        ...n.lockPluginFilter ? { filter: n.lockPluginFilter } : {}
      },
      setup: (S) => {
        S.on("click", o), S.on("render", i), S.on("select", l);
      }
    }), () => {
      s.current && (s.current.off("click", o), s.current.off("render", i), s.current.off("select", l), s.current.destroy(), s.current = null);
    };
  }, []), M.useEffect(() => {
    !s.current || !n.period || (r({
      start: n.period.start,
      end: n.period.end
    }), s.current.setDateRange(n.period.start, n.period.end), s.current.gotoDate(n.period.start));
  }, [n.period]), /* @__PURE__ */ y.jsxs("div", { className: "flex flex-auto flex-col", children: [
    n.isWidget ? null : /* @__PURE__ */ y.jsx(Qe, { locale: n.lang }),
    /* @__PURE__ */ y.jsx(
      "div",
      {
        className: ge("flex-auto text-center", { relative: !n.isWidget }),
        children: /* @__PURE__ */ y.jsxs(
          "div",
          {
            className: ge("inset-0 overflow-y-auto lg:static", {
              absolute: !n.isWidget
            }),
            children: [
              /* @__PURE__ */ y.jsx("input", { id: c, type: "hidden" }),
              /* @__PURE__ */ y.jsx("input", { id: g, type: "hidden" })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ y.jsx("div", { className: "relative bg-gray-25 p-4 text-center", children: /* @__PURE__ */ y.jsxs("div", { className: "mx-auto max-w-sm", children: [
      /* @__PURE__ */ y.jsx(
        Wt,
        {
          dayDifference: w,
          labels: n.labels.bookingPeriod,
          selectedBookingPeriod: n.selectedBookingPeriod ?? null,
          settings: t,
          onButtonClick: (h) => {
            var v;
            (v = n.onChangeBookingPeriod) == null || v.call(n, h);
          }
        }
      ),
      /* @__PURE__ */ y.jsxs("div", { className: "mb-2 capitalize", children: [
        p,
        " ",
        w > 0 && /* @__PURE__ */ y.jsxs("span", { className: "normal-case text-secondary", children: [
          "(",
          w,
          " ",
          w === 1 ? n.labels.day : n.labels.days,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ y.jsx(
        ee,
        {
          type: "button",
          fullWidth: !0,
          onClick: () => {
            var h;
            e && ((h = n.onConfirm) == null || h.call(n, e));
          },
          disabled: !e,
          fontSize: "lg",
          isLoading: n.isLoading,
          children: n.labels.confirmBtn
        }
      )
    ] }) })
  ] });
}
const Zt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars .calendar:nth-child(n+2){display:block}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar{padding:8px}.calendar>.header{padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{padding:0;border:none;border-radius:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1)}.calendar>.header .previous-button,.calendar>.header .next-button{display:none}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row{display:none}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}@media (min-width: 992px){.calendars{padding:40px 16px 24px;grid-template-columns:repeat(2,1fr)}.calendars .calendar>.daynames-row{display:grid}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button{display:flex;position:absolute;top:5px}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button>svg,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button>svg{height:24px;width:auto}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:first-child>.header .previous-button{left:0}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar:nth-child(2)>.header .next-button{right:0}.calendars .calendar{padding:8px 24px}.calendars .calendar:nth-child(n+3){display:none}}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}.calendar>.days-grid>.day.absence{background-color:var(--blue-500, #046dd7);color:var(--white, #fff)}.calendar>.days-grid>.day.absence.absence-disabled{opacity:.2;cursor:default;pointer-events:none}.calendar>.days-grid>.day.sold{pointer-events:none;background-color:var(--yellow-500, #b35502);color:var(--white, #fff)}';
function Kt(n, t) {
  const e = /* @__PURE__ */ new Map(), r = n.map(
    (i) => O.fromISO(i.startDate).toSeconds()
  ), o = Array.from(t).map(
    (i) => i / 1e3
  );
  return r.filter((i) => !o.includes(i)).forEach(
    (i) => e.set(He(i), "removed")
  ), o.filter((i) => !r.includes(i)).forEach((i) => e.set(He(i), "added")), e;
}
function He(n) {
  return O.fromSeconds(n).toISODate();
}
const Ve = "share-date-picker", ce = "absence", We = "absence-disabled", Ue = "sold";
function qe(n) {
  const t = O.now().startOf("day").toJSDate();
  return n.getTime() >= t.getTime() ? n : t;
}
function Je(n, t, e) {
  const r = O.now().startOf("day").toMillis(), o = n - r;
  return o < 0 ? !1 : typeof e != "number" || !t.find(
    (l) => O.fromISO(l.startDate).toMillis() === n
  ) ? !0 : o <= e;
}
function ir(n) {
  const t = M.useRef(null), e = M.useRef(/* @__PURE__ */ new Set()), r = M.useRef(
    n.daysSold.map((h) => O.fromISO(h).toMillis())
  ), [o, i] = M.useState(!1), l = M.useCallback((h) => {
    if (h.detail.view !== "Container")
      return;
    const v = h.target;
    r.current.forEach((D) => {
      const S = v.querySelector(
        `.day.unit[data-time="${D}"]`
      );
      S && S.classList.add(Ue);
    }), v.querySelectorAll(`.day.${ce}`).forEach((D) => {
      D.classList.remove(ce), D.classList.remove(We);
    }), e.current.forEach((D) => {
      const S = v.querySelector(
        `.day.unit[data-time="${D}"]`
      );
      S && (S.classList.add(ce), Je(D, n.absences, n.absenceRemoveLimit) || S.classList.add(We));
    });
  }, []);
  function s(h, v) {
    if (h < O.now().startOf("day").toJSDate().getTime())
      return;
    const S = v.querySelector(
      `.day.unit[data-time="${h}"]`
    );
    S && (S.classList.contains(Ue) || (e.current.has(h) ? Je(h, n.absences, n.absenceRemoveLimit) && e.current.delete(h) : e.current.add(h)));
  }
  const c = M.useCallback(
    (h) => {
      var v;
      h.target && (s(h.detail.date.getTime(), h.target), (v = t.current) == null || v.clear());
    },
    []
  );
  M.useEffect(() => {
    var S;
    e.current = new Set(
      n.absences.map((_) => O.fromISO(_.startDate).toMillis())
    );
    const h = document.getElementById(Ve);
    if (!h)
      return;
    const v = qe(n.reservation.startDate), D = {
      LockPlugin: {
        inseparable: !0,
        minDate: n.reservation.startDate,
        maxDate: n.reservation.endDate
      }
    };
    return t.current = new he.create({
      element: h,
      css: Zt,
      firstDay: 1,
      lang: n.lang,
      format: "YYYY-MM-DD",
      calendars: n.calendars,
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [fe],
      setup(_) {
        _.on("render", l), _.on("select", c);
      },
      ...D
    }), (S = t.current) == null || S.gotoDate(v), () => {
      t.current && (t.current.off("render", l), t.current.off("select", c), t.current.destroy(), t.current = null, e.current = /* @__PURE__ */ new Set());
    };
  }, []);
  async function g() {
    try {
      const h = Kt(n.absences, e.current);
      if (h.size === 0)
        return;
      i(!0), await n.saveSharingChanges(h);
    } finally {
      i(!1), n.onCloseDialog();
    }
  }
  function p() {
    var S;
    if (!t.current)
      return;
    const h = O.fromJSDate(n.reservation.endDate).endOf("day").toJSDate().getTime(), v = qe(n.reservation.startDate);
    let D = O.fromJSDate(v).startOf("day");
    for (let _ = D.toJSDate().getTime(); _ <= h; _ = D.toJSDate().getTime())
      e.current.has(_) || s(_, t.current.ui.container), D = D.plus({ days: 1 }).startOf("day");
    (S = t.current) == null || S.clear();
  }
  function w() {
    var h;
    e.current.forEach((v) => {
      t.current && s(v, t.current.ui.container);
    }), (h = t.current) == null || h.clear();
  }
  return /* @__PURE__ */ y.jsxs("div", { className: "flex flex-auto flex-col", children: [
    /* @__PURE__ */ y.jsxs("div", { className: "mt-4 flex items-center justify-center gap-4", children: [
      /* @__PURE__ */ y.jsx(
        ee,
        {
          onClick: p,
          variant: "outline",
          className: "hover:border-blue-500 hover:bg-blue-500",
          children: n.labels.selectAllBtn
        }
      ),
      /* @__PURE__ */ y.jsx(
        ee,
        {
          onClick: w,
          variant: "outline",
          className: "hover:border-blue-500 hover:bg-blue-500",
          children: n.labels.deselectAllBtn
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx(Qe, { locale: n.lang }),
    /* @__PURE__ */ y.jsx("div", { className: "relative flex-auto text-center", children: /* @__PURE__ */ y.jsx("div", { className: "absolute inset-0 overflow-y-auto lg:static", children: /* @__PURE__ */ y.jsx("input", { id: Ve, type: "hidden" }) }) }),
    /* @__PURE__ */ y.jsx("div", { className: "relative bg-gray-50 p-4 text-center", children: /* @__PURE__ */ y.jsx(
      ee,
      {
        fullWidth: !0,
        type: "button",
        onClick: g,
        disabled: o,
        isLoading: o,
        children: n.labels.confirmBtn
      }
    ) })
  ] });
}
const Xt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars{padding:24px 0 16px}@media (max-width: 480px){.calendars{padding:8px 0}}.calendars .calendar:nth-child(n+2){display:none}@media (min-width: 992px){.calendars .calendar:nth-child(n+2){display:block}}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}.calendars.grid-2{grid-template-columns:none}@media (min-width: 992px){.calendars{padding:32px 16px 24px}.calendars.grid-2{grid-template-columns:repeat(2,1fr)}.calendars:not(.grid-1) .calendar>.header .next-button{visibility:hidden}}.calendar{padding:8px 24px}@media (max-width: 480px){.calendar{padding:8px}}.calendar>.header{position:relative;padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{position:absolute;top:5px;padding:0;border:none;border-radius:0}.calendar>.header button.previous-button{left:0}.calendar>.header button.next-button{right:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1);height:24px;width:auto}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.inline{min-height:unset}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}:host{--day-height: 40px;--day-width: 40px;--day-gap: 4px}.calendars{padding:0}.calendars .calendar>.days-grid>.day{width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width)}.calendars .calendar>.daynames-row>.dayname{width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width)}.calendar{padding:0}.calendar>.days-grid{gap:var(--day-gap);max-width:calc(var(--day-width) * 7 + var(--day-gap) * 6)}.calendar>.days-grid>.day.selected-day{background-color:var(--blue-500, #00B0FF);color:var(--white, #fff)}.calendar>.days-grid>.day.unavailable-day{color:var(--color-fg-locked, #9e9e9e);cursor:default;pointer-events:none;text-decoration:line-through}.calendar .daynames-row{max-width:calc(var(--day-width) * 7 + var(--day-gap) * 6);row-gap:var(--day-gap)}', Ge = "timeschedule-picker", ue = "selected-day", Ze = "unavailable-day";
function dr(n) {
  const t = M.useRef(null), e = M.useRef([]), r = M.useRef([]), o = M.useCallback(function(s) {
    if (s.detail.view !== "Container")
      return;
    const c = s.target;
    [ue, Ze].forEach((g) => {
      c.querySelectorAll(`.day.${g}`).forEach((p) => p.classList.remove(g));
    }), e.current.forEach((g) => {
      const p = c.querySelector(
        `.day.unit[data-time="${g}"]`
      );
      p && p.classList.add(ue);
    }), e.current.forEach((g) => {
      var p;
      (p = c.querySelector(`.day.unit[data-time="${g}"]`)) == null || p.classList.add(ue);
    }), r.current.forEach((g) => {
      var p;
      (p = c.querySelector(`.day.unit[data-time="${g}"]`)) == null || p.classList.add(Ze);
    });
  }, []), i = M.useCallback(
    (l) => {
      n.onDateSelect(l.detail.date.getTime());
    },
    [n.onDateSelect]
  );
  return M.useEffect(() => {
    var l;
    e.current = [...n.selectedDates], r.current = [...n.unavailableDays], (l = t.current) == null || l.clear();
  }, [n.selectedDates, n.unavailableDays]), M.useEffect(() => {
    var c;
    const l = document.getElementById(Ge);
    if (!l)
      return;
    const s = {
      LockPlugin: {
        minDate: n.minDate,
        maxDate: n.maxDate
      }
    };
    return t.current = new he.create({
      element: l,
      css: Xt,
      firstDay: 1,
      lang: n.lang,
      format: "YYYY-MM-DD",
      calendars: 1,
      // grid: 1,
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [fe],
      setup(g) {
        g.on("render", o), g.on("select", i);
      },
      ...s
    }), (c = t.current) == null || c.gotoDate(n.minDate), () => {
      t.current && (t.current.off("render", o), t.current.off("select", i), t.current.destroy(), t.current = null);
    };
  }, []), /* @__PURE__ */ y.jsx("div", { className: "flex flex-auto flex-col", children: /* @__PURE__ */ y.jsx("div", { className: "relative flex-auto text-center", children: /* @__PURE__ */ y.jsx("input", { id: Ge, type: "hidden" }) }) });
}
export {
  te as BookingHalfDay,
  I as BookingPeriod,
  or as DatePicker,
  Qe as DatePickerHeader,
  ir as SharingDatePicker,
  dr as TimeScheduleCalendar,
  Ot as getCalendarsByPeriod,
  Nt as isSameDay,
  zt as useDatePicker,
  $t as useFormattedPeriod
};
